<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-8 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('close')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">
              {{ $t("teachers.edit.editingTeacher") }}
            </p>

            <form @submit.prevent="submitForm">
              <div class="d-flex">
                <div class="col-xl-5 mx-5">
                  <div class="mb-3">
                    <InputForm
                      v-model="formData.name"
                      :placeholder="localTeacher.name"
                      type="text"
                    />
                  </div>
                  <div class="mb-3">
                    <InputForm
                      v-model="formData.email"
                      :placeholder="localTeacher.email"
                      type="text"
                      @select-change="handleFirstSelectChange"
                    />
                  </div>
                  <div class="mb-3">
                    <InputForm
                      v-model="formData.mobile"
                      :placeholder="
                        localTeacher.mobile
                          ? localTeacher.mobile
                          : $t('teachers.mobile')
                      "
                      type="text"
                    />
                  </div>
                  <div class="mb-3">
                    <InputForm
                      v-model="formData.address"
                      :placeholder="
                        localTeacher.address
                          ? localTeacher.address
                          : $t('teachers.address')
                      "
                      type="text"
                    />
                  </div>
                  <div class="mb-3">
                    <p v-for="sub in localTeacher.subcourses" :key="sub.id">
                      {{ sub.title }}
                      <a
                        class="text-danger text-gradient mb-0 mx-3"
                        href="javascript:;"
                        @click="deleteSubcourse(sub.id)"
                      >
                        <i class="far fa-trash-alt me-1" aria-hidden="true"></i
                        >{{ $t("global.delete") }}</a
                      >
                    </p>
                  </div>
                </div>
                <div class="col-xl-5 mx-2">
                  <div class="mb-3">
                    <SelectFormCourse
                      @select="getSubcourses"
                      v-model="courses"
                      :selectedOption="$t('courses.selectCourse')"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectFormSubcourse
                      @select1="setSubcourse"
                      v-model="subcourses"
                      :isDisabled="!subcourses.length"
                      :selectedOption="$t('subcourses.selectSubcourse')"
                    />
                  </div>
                  <div class="align-text-center justify-content-center">
                    <div style="display: inline-block">
                      <img
                        :src="localTeacher.image"
                        class="right-img mb-2 mx-2"
                      />
                    </div>
                    <label
                      style="display: inline-block"
                      for="file"
                      :v-model="formData.file"
                      class="mx-2 custom-file-upload"
                      ><span>{{ $t("global.uploadImage") }}</span>
                    </label>
                    <input
                      type="file"
                      id="file"
                      @change="handleFileUpload"
                      accept="image/*"
                    />
                  </div>
                </div>
              </div>
              <div class="text-center col-4 mx-auto">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.edit") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
import SelectFormCourse from "@/components/SelectFormCourse.vue";
import SelectFormSubcourse from "@/components/SelectFormSubcourse.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
//import DatePicker from "@/components/DatePicker.vue";
import swal from "sweetalert2";

export default {
  name: "FormCreateTeacher",
  components: {
    InputForm,
    SelectFormCourse,
    SelectFormSubcourse,
    SoftButton,
    SoftBadge,
    //DatePicker,
  },
  props: {
    teacher: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      formData: {
        id: this.teacher.id,
        name: "",
        email: "",
        mobile: "",
        address: "",
        subcourse: [],
        date: "",
      },
      courses: [],
      subcourses: [],
      selectedFile: "",
      selectedCourse: null,
      selectedSubcourse: null,
      isFirstSelected: false,
      imageUrl: "",
      localTeacher: { ...this.teacher },
    };
  },
  created() {
    this.getCourses();
  },
  watch: {
    teacher(newTeacher) {
      this.localTeacher = { ...newTeacher };
    },
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("_method", "PATCH");
      formData.append("id", this.formData.id);
      if (this.formData.name != "") {
        formData.append("name", this.formData.name);
      }
      if (this.formData.email != "") {
        formData.append("email", this.formData.email);
      }
      if (this.formData.mobile != "") {
        formData.append("mobile", this.formData.mobile);
      }
      if (this.formData.date != "") {
        formData.append("employed_from", this.formData.date);
      }
      if (this.formData.address != "") {
        formData.append("address", this.formData.address);
      }
      if (this.formData.subcourse != "") {
        formData.append("subcourse", this.formData.subcourse);
      }
      if (this.selectedFile != "") {
        formData.append("image", this.selectedFile);
      }
      if (this.formData.date != "") {
        formData.append("date", this.formData.date);
      }

      try {
        const response = await axios.post(
          "teacher/" + this.localTeacher.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status == 200) {
          this.resetForm();
          swal.fire({
            icon: "success",
            title: this.$t("teachers.teacherUpdated"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.localTeacher = response.data.teacher;
          this.$emit("close-edit-form", this.localTeacher);
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.selectedFile = file;

      // Kreiranje URL za prikazivanje pregleda slike
      this.imageUrl = URL.createObjectURL(file);
    },
    async getCourses() {
      const response = await axios.get("courses/all");
      this.courses = response.data.courses;
    },
    async getSubcourses(selectedCourse) {
      const response = await axios.get("subcourses/course/" + selectedCourse);
      this.subcourses = response.data.subcourses;
    },
    setSubcourse(selectedSubcource) {
      this.formData.subcourse = selectedSubcource;
    },
    async deleteSubcourse(subcourseId) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: "",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            "delete-teacher-subcourse/" + this.teacher.id + "/" + subcourseId
          );
          this.localTeacher = response.data.teacher;
          swal.fire({
            icon: "success",
            title: response.data.message,
            showConfirmButton: true,
            width: "64em",
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        swal.fire({
          title: "Brisanje otkazano!",
          text: "",
          icon: "success",
        });
      }
    },
    handleFirstSelectChange(selectedValue) {
      this.isFirstSelected = !!selectedValue; // Proverava da li je vrednost izabrana
    },
    resetForm() {
      this.formData.name = "";
      this.formData.email = "";
      this.formData.mobile = "";
      this.formData.employed_from = "";
      this.formData.address = "";
      this.formData.subcourse = null;
      this.formData.date = "";
      this.selectedFile = null;

      return;
    },
  },
};
</script>

<style scoped>
.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  background: linear-gradient(to right, #7fe02f, #2cb735);
  color: white;
  border-radius: 8px;
}

#file {
  display: none;
}

.custom-file-upload span {
  pointer-events: none;
}

.float-right {
  float: right;
}

.right-img {
  position: relative;
  border: 1px solid gray;
  padding: 6px;
  border-radius: 8px;
  width: 125px !important;
  height: 125px !important;
}
</style>
